import { Observable, map } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config-service/config.service';
import { LoginService } from '../login-service/login.service';

@Injectable({
  providedIn: 'root',
})
export class SdsFileService {
  public config: any = null;
  arrayFile: any;
  constructor(
    private configService: ConfigService,
    private loginService: LoginService,
    private http: HttpClient
  ) {
    const strConfig = localStorage.getItem('config-service');
    if (strConfig !== null) this.config = JSON.parse(strConfig);
    else {
      this.configService._config_$.subscribe((x) => {
        this.config = x;
      });
    }
  }

  getSdsFile(clientData: any) {
    const token = this.loginService.getSessionToken();
    if (token === null) this.loginService.signout();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    const paramsObj = {
      email: clientData['contact-info'].email,
    };
    const params = new HttpParams({ fromObject: paramsObj });
    return this.http.post(
      `${this.config.sdsGetFile}`,
      null,
      {
      headers: headers,
        params: params,
    }
    );
  }

  getPreassignedUrl(files: any) {
    const headers: any = { 'Content-Type': 'application/json' };
    const options: any = { headers: headers };
    const body: any = { name: files.file_name };

    return this.http.post(`${this.config.presignedURL}`, body, options);
  }

  uploadFileToAWS(signedURL: any, fileBlob: any) {
    const headers: any = { 'Content-Type': 'application/pdf' };
    const options: any = { headers: headers };
    return this.http.put(signedURL, fileBlob, options);
  }

  submitSDSFile(files: any): Observable<any> {
    const token = this.loginService.getSessionToken();
    if (token === null) this.loginService.signout();
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };

    const requestBody = {
      'sds-file': [files],
    };

    return this.http.post(this.configService.sdsFileUpload, requestBody, {
      headers,
    });
  }

  deleteSdsFile(id: any) {
    const token = this.loginService.getSessionToken();
    if (token === null) this.loginService.signout();
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };

    const requestBody = {
      id: id,
    };
    return this.http.post(this.config.sdsDeteleFile, requestBody, {
      headers,
    });
  }

  getUserSearchHistory(
    clientData: any,
    sorting: any = 'desc',
    isFavorite: any = '',
    isAlert: any = ''
  ) {
    const token = this.loginService.getSessionToken();
    if (token === null) {
      this.loginService.signout();
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    const email = clientData['contact-info']?.email;

    // Create HttpParams for the parameters
    const params = new HttpParams()
      .set('email', email || '')
      .set('isFavorite', isFavorite || '')
      .set('sorting', sorting || 'desc')
      .set('isAlert', isAlert || '');

    const url = this.config.userSearchHistory;

    // Send a POST request with null body, headers, and parameters
    return this.http.post(
      url,
      null, // No request body
      {
        headers: headers,
        params: params,
      }
    );
  }

  getAlertRailcarInventory(clientData: any, user_search_id: any) {
    const token = this.loginService.getSessionToken();
    if (token === null) this.loginService.signout();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    const email = clientData['contact-info']?.email;
    const url = `${this.config.alertRailcarInventory}?email=${email}&user_search_id=${user_search_id}`;
    return this.http.post(
      url,
      {},
      {
        headers: headers,
      }
    );
  }

  updateFavoriteRailcarInventory(clientData: any, user_search_id: any): any {
    const token = this.loginService.getSessionToken();

    if (token === null) {
      this.loginService.signout();
      return; // Exit early if the token is null
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    const email = clientData['contact-info']?.email;
    const url = `${this.config.updateFavoriteQuote}?email=${email}&user_search_id=${user_search_id}`;
    return this.http.post(
      url,
      {},
      {
        headers: headers,
      }
    );
  }

  submitFeedback(feedbackData: any): Observable<any> {
    const token = this.loginService.getSessionToken();
    if (token === null) this.loginService.signout();
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };

    return this.http.post(this.configService.submitFeedback, feedbackData, {
      headers,
    });
  }
}
